export default __webpack_public_path__ + "d5494fdee70030dc5095d7e56c4929b0.gif";